import { CellContext } from '@tanstack/react-table';
import { creatorbase } from '@round/api';
import { getTableMetaHelper, Image, SkeletonizedValue } from '@round/ui-kit';
import { ProjectTableMeta } from '../../types';
import styles from './ProjectCell.module.css';
import { TooltipOnOverflow } from '@round/whitelabel-ui';

type Row = creatorbase.Project & {
    team: creatorbase.Team | null;
};

type Context<T extends Row> = CellContext<T, T['name']>;

const getTableMeta = getTableMetaHelper<ProjectTableMeta<Row>>();

const ProjectCell = <T extends Row>({ getValue, row: { original }, table }: Context<T>) => {
    const { getIsRowLoading, isTeamLoading } = getTableMeta(table);
    const isRowLoading = getIsRowLoading(original);
    const isTeamSkeleton = isRowLoading || (isTeamLoading?.(original) ?? false);

    const projectName = getValue();
    const teamName = original.team?.name;

    return (
        <div className={styles.container}>
            <Image className={styles.image} src={original.image ?? ''} loading={isRowLoading} skeletonCircle={false} />
            <div className={styles.names}>
                <SkeletonizedValue isInitialized={!isRowLoading} width="75%">
                    <TooltipOnOverflow tooltip={projectName}>
                        <p>{projectName}</p>
                    </TooltipOnOverflow>
                </SkeletonizedValue>

                <SkeletonizedValue isInitialized={!isTeamSkeleton} width="50%">
                    <p className={styles.subValue}>{teamName}</p>
                </SkeletonizedValue>
            </div>
        </div>
    );
};

export default ProjectCell;
